import React from 'react';
import { Row, Col, FormControl, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Comments = ({ comment, onCommentChange, showLabel = true }) => (
    <Row>
        {showLabel && (
            <Col componentClass={ControlLabel} sm={12}>
                Comment
            </Col>
        )}
        <Col sm={12}>
            <FormControl
                name="comment"
                componentClass="textarea"
                placeholder="Enter comment..."
                value={comment}
                onChange={onCommentChange}
                style={{ resize: 'vertical' }}
                rows={7}
                maxLength="1000"
            />
        </Col>
    </Row>
);

Comments.propTypes = {
    comment: PropTypes.string,
    showLabel: PropTypes.bool,
    onCommentChange: PropTypes.func,
};

export default Comments;
